import { useState } from "react";
import { GraduationCap, Sparkles } from "lucide-react";
import { LeadFormDialog } from "@/components/LeadFormDialog";

// Premium top-bar CTA — meant to be impossible to ignore even while a user is
// deep into a Mushaf reading session. It uses a subtle "shine" sweep animation
// + an amber halo so it visually stands out from the otherwise green/cream
// header palette. Click → opens the live-classes lead form (Name / Country /
// Email / Mobile) — same one the floating bubble & /lessons hero use.
export const LiveClassesNavCTA = ({ compact = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="nav-live-classes-cta"
        className={`relative group inline-flex items-center gap-1.5 rounded-full
          bg-gradient-to-br from-emerald-700 via-emerald-600 to-emerald-700
          text-white font-medium shadow-md
          ring-1 ring-amber-300/60 hover:ring-amber-300
          transition-all duration-200 ease-out hover:shadow-lg hover:scale-[1.02]
          whitespace-nowrap overflow-hidden
          ${compact ? "h-9 px-3 text-xs" : "h-10 px-4 text-[13px] sm:text-sm"}`}
        style={{ boxShadow: "0 6px 22px -10px hsla(160,84%,18%,0.6), 0 0 0 3px hsla(45,64%,52%,0.18)" }}
      >
        {/* Diagonal shine sweep on hover */}
        <span
          aria-hidden
          className="absolute inset-y-0 -left-12 w-12 bg-white/25 skew-x-[-20deg] transition-transform duration-700 ease-out group-hover:translate-x-[200%]"
        />
        <span className="relative inline-flex items-center gap-1.5">
          <span className="relative w-5 h-5 rounded-full bg-amber-300/95 text-emerald-900 inline-flex items-center justify-center">
            <GraduationCap className="w-3 h-3" />
            <Sparkles className="w-2 h-2 text-emerald-900 absolute -top-0.5 -right-0.5 animate-pulse" />
          </span>
          <span className={compact ? "" : "hidden sm:inline"}>Book Live Free Class</span>
          <span className={compact ? "hidden" : "sm:hidden"}>Book Live Free Class</span>
        </span>
      </button>

      <LeadFormDialog open={open} onOpenChange={setOpen} source="nav-cta" />
    </>
  );
};
